module.exports = __webpack_public_path__ + "static/media/ic_userGuide_vacana.28adbd03.png";